import psHttp from '@patsnap/common-ps-http';
import _ from 'lodash';
import { lifeScienceApiUrlPrefix } from '../../config/constants';

function done(res) {
    return _.get(res, 'data.results', {});
}

export function getFolders() {
    return psHttp({
        url: `${lifeScienceApiUrlPrefix}/msa/folder`,
        method: 'GET',
    }).then(done);
}

export function updateFolderName({ folderId, folderName }) {
    return psHttp({
        method: 'PUT',
        url: `${lifeScienceApiUrlPrefix}/msa/folder/${folderId}`,
        data: {
            folder_name: folderName,
        },
    }).then(done);
}

export function addFolder({ folderName, folderType, sequenceType, parentId }) {
    return psHttp({
        url: `${lifeScienceApiUrlPrefix}/msa/folder`,
        method: 'POST',
        data: {
            folder_name: folderName,
            folder_type: folderType,
            sequence_type: sequenceType,
            parent_id: parentId,
        },
    }).then(done);
}

export function addSequenceBatch(folderId, sequenceList, patentId) {
    return psHttp({
        url: `${lifeScienceApiUrlPrefix}/msa/folder/${folderId}/sequence`,
        method: 'POST',
        data: {
            sequence_list: sequenceList,
            patent_id: patentId || undefined,
        },
    }).then(done);
}

export function checkRangeSequenceToMsaApi(params) {
    const { patentId } = params;
    return psHttp({
        url: `${lifeScienceApiUrlPrefix}/msa/patent/${patentId}/check`,
        method: 'GET',
        params,
    }).then(done);
}

export function getSequenceDetailByUkApi(bioUk, patentId, folderId) {
    return psHttp({
        url: `${lifeScienceApiUrlPrefix}/sequence/uk/detail`,
        uuid: `${lifeScienceApiUrlPrefix}/sequence/uk/detail/${patentId}`,
        method: 'POST',
        data: { bio_uk: _.isArray(bioUk) ? bioUk : [bioUk], patent_id: patentId, folder_id: folderId },
    }).then(done);
}

export function seqAlignment(params) {
    return psHttp({
        method: 'POST',
        url: `${lifeScienceApiUrlPrefix}/sequence/alignment`,
        data: params,
    }).then(done);
}

export function getSequenceBatchApi(params) {
    return psHttp({
        url: `${lifeScienceApiUrlPrefix}/sequence/batch`,
        method: 'POST',
        data: params,
    }).then(res => {
        return _.get(res, 'data.data', {});
    });
}

export function getSequenceDetailBySeqNoApi(patentId, seqNo) {
    return psHttp({
        url: `${lifeScienceApiUrlPrefix}/sequence?sequenceNo=${seqNo}&patentId=${patentId}`,
        uuid: `/sequence?sequenceNo=${seqNo}&patentId=${patentId}`,
        method: 'GET',
    }).then(res => {
        return _.get(res, 'data.data', {});
    });
}

export function getSequenceListById(patentId, bioUk, fields) {
    return psHttp({
        method: 'GET',
        url: `${lifeScienceApiUrlPrefix}/sequence/highlight-helper/patent/${patentId}?bio_uk=${bioUk}&field=${fields}`
    }).then(res => {
        return _.get(res, 'data', {});
    });
}

export function submitSequenceApi(params, patent_id) {
    return psHttp({
        url: `${lifeScienceApiUrlPrefix}/assistant/alignment/submit`,
        method: 'POST',
        data: {
            ...params,
            patent_id,
        },
    }).then(done);
}

export function getSequenceResultApi(params, patent_id) {
    return psHttp({
        url: `${lifeScienceApiUrlPrefix}/assistant/alignment/result`,
        method: 'POST',
        data: {
            ...params,
            patent_id,
            rows: 50
        },
    }).then(done);
}

export function getSequenceMatchResultApi(params, patent_id) {
    return psHttp({
        url: `${lifeScienceApiUrlPrefix}/assistant/sequences`,
        method: 'POST',
        data: {
            ...params,
            patent_id,
        },
    }).then(done);
}

export function getAllHighLightKeysApi(params, patent_id) {
    return psHttp({
        url: `${lifeScienceApiUrlPrefix}/assistant/alignment/highlight-key`,
        method: 'POST',
        data: {
            ...params,
            patent_id,
        },
    }).then(done);
}

export function getSequenceCount(patentId) {
    return psHttp({
        method: 'GET',
        url: `${lifeScienceApiUrlPrefix}/assistant/${patentId}/sequence-count`
    }).then(res => {
        return _.get(res, 'data', {});
    });
}

export function getExportQuery(patentId, data) {
    return psHttp({
        url: `${lifeScienceApiUrlPrefix}/assistant/${patentId}/export-query`,
        method: 'POST',
        data,
    }).then(done).catch(err => {
        return _.get(err, 'response.data', {});
    });
}

export function getExtraSequenceCount(data) {
    return psHttp({
        headers: {
            'X-API-Version': '1.0',
        },
        url: `${lifeScienceApiUrlPrefix}/search/extract-sequence-count`,
        method: 'POST',
        data,
    }).then(done).catch(err => {
        return _.get(err, 'response.data', {});
    });
}

export function getExtraQuery(data) {
    return psHttp({
        headers: {
            'X-API-Version': '1.0',
        },
        url: `${lifeScienceApiUrlPrefix}/group/adapter`,
        method: 'POST',
        data,
    }).then(done).catch(err => {
        return _.get(err, 'response.data', {});
    });
}

export function getFamilyPatentHighlight(patentId) {
    return psHttp({
        url: `${lifeScienceApiUrlPrefix}/assistant/${patentId}/family-patent-highlight`,
        method: 'GET',
    }).then(done).catch(err => {
        return _.get(err, 'response.data', false);
    });
}

export function getFamilyPatentSequences(patentId) {
    return psHttp({
        url: `${lifeScienceApiUrlPrefix}/assistant/${patentId}/family-patent-sequence`,
        method: 'GET',
    }).then(done).catch(err => {
        return _.get(err, 'response.data', []);
    });
}

/**
 * 用于workspace 中target sequence 列展示搜索类型标签，传入bio uk列表
 */
export function getBioUkByTargetSequence(data) {
    return psHttp({
        url: `${lifeScienceApiUrlPrefix}/workspace/search-type`,
        method: 'POST',
        cache: true,
        data
    }).then(done).catch(err => {
        return _.get(err, 'response.data', []);
    });
}

export function transformSelectSeqs(params) {
    return psHttp({
        url: `${lifeScienceApiUrlPrefix}/common/special-query`,
        method: 'POST',
        data: {
            special_query_type: 'SAVE_SEQUENCE',
            ...params,
        },
    })
        .then((res) => _.get(res, 'data.results.bio_uk'));
}

/**
 * 前端手动埋点
 * @param params
 * @returns {Promise<{}>}
 */
export function trackUserEventApi(params) {
    return psHttp({
        method: 'POST',
        url: `${lifeScienceApiUrlPrefix}/track/log`,
        data: params,
    }).then(done);
}
